import { createTheme } from '@mui/material/styles';
import '@fontsource/poppins';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

const Theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
  components: {
    // Typography
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
        },
      },
    },

    // Buttons
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
          textTransform: 'none',
        },
      },
    },

    // TextField defaults
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
        },
      },
    },

    // Base Input
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
          fontSize: '0.9rem',
        },
      },
    },

    // Outlined Input (TextField & DatePicker)
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ccc',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#a855f7', 
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#7C0BCC', 
            borderWidth: '2px',
          },
        },
      },
    },

    // Input Label
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif',
          fontSize: '0.95rem',
          '&.Mui-focused': {
            color: '#7C0BCC', // Label focus color
          },
        },
      },
    },

    // Date Picker Components
    // MuiDatePicker: {
    //   defaultProps: {
    //     slotProps: {
    //       textField: {
    //         size: 'small',
    //         sx: {
    //           '& .MuiOutlinedInput-notchedOutline': {
    //             borderColor: '#ccc',
    //           },
    //           '&:hover .MuiOutlinedInput-notchedOutline': {
    //             borderColor: '#a855f7', // Hover border color
    //           },
    //           '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    //             borderColor: '#7C0BCC', // Focus border color
    //             borderWidth: '2px',
    //           },
    //           '& .MuiInputLabel-root.Mui-focused': {
    //             color: '#7C0BCC', // Label focus color
    //           },
    //         },
    //       },
    //     },
    //   },
    // },
  },
});

export default Theme;
